import { useRuntimeConfig } from '#imports'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './useReducedGrades.translations'

export function useReducedGrades() {
  const i18n = useI18n()
  const experiments = useExperiments()
  const { FF_PRODUCT_PAGE_EXCLUDED_GRADES_RENAME_EXPERIMENT = '' } =
    useRuntimeConfig().public

  const getGradeLabel = (
    categoryId: number,
    gradeId: number,
    gradeName: string | null,
  ) => {
    if (
      experiments['experiment.twoGradesRename'] === 'new' &&
      !FF_PRODUCT_PAGE_EXCLUDED_GRADES_RENAME_EXPERIMENT.split(',').includes(
        String(categoryId),
      )
    ) {
      if (gradeId === 10) {
        return i18n(translations.gradeFlawlessScreenlessDevices)
      }

      if (gradeId === 11) {
        return i18n(translations.gradeGentlyUsedScreenlessDevices)
      }
    }

    return gradeName
  }

  return { getGradeLabel }
}
